<div class="bg-white p-3">
    <h1>{{'ERROR_PERMISSION_DENIED' | translate}}</h1>
    <p>
        {{'ERROR_PERMISSION_DENIED_DESCRIPTION' | translate}}
    </p>
</div>